import React, { useState } from 'react';
import { useI18n } from '@udemy/i18n';
import { StoreProvider } from '@udemy/store-provider';
import { useUDData } from '@udemy/ud-data';
import { CoursePriceStore } from './stores/course-price-store/course-price-store';
import { UserSettingsStore } from './stores/user-settings-store/user-settings-store';
export function CommonStoresProvider({
  children
}) {
  // Instantiate common stores here.
  // NOTE: store constructors should have no logic to keep this step as light-weight as possible
  const [coursePriceStore] = useState(() => new CoursePriceStore());
  const [userSettingsStore] = useState(() => new UserSettingsStore());
  const commonStores = [coursePriceStore, userSettingsStore];

  // Read UDData and set it on all stores
  const udData = useUDData();
  const i18n = useI18n();
  commonStores.forEach(store => {
    store.providerUpdate({
      udData,
      i18n
    });
  });
  return /*#__PURE__*/React.createElement(StoreProvider, {
    stores: commonStores
  }, children);
}
//# sourceMappingURL=provider.js.map